import { script_dynatrace } from '../../userManager/settings';

export default function () {
  // inject MCP SDK
  const script = document.createElement('script');
  script.src = script_dynatrace;
  script.type = 'text/javascript';
  script.crossOrigin = 'anonymous';
  script.async = true;

  document.head.appendChild(script);
  console.info('dynatrace loaded');
}
